// extracted by mini-css-extract-plugin
export var chevron = "_md-3";
export var chevronRotated = "_md-4";
export var image = "_md-1";
export var imageContainer = "_md-0";
export var shippingAddress = "_md-2";